import { useEffect, useRef } from "react";
import { toast } from "react-toastify";
import { favoritesService, IFavoriteResult } from "../services/favoritesService";
import { PENDING_FAVORITE_ID_KEY } from "../auth/pendingAuthActions";

const inFlightFavoriteIds = new Set<number>();

export function usePendingFavoriteAfterAuth(
    authLoading: boolean,
    user: unknown,
    onUpdated: (id: number, result: IFavoriteResult) => void
): void {
    const onUpdatedRef = useRef(onUpdated);
    onUpdatedRef.current = onUpdated;

    useEffect(() => {
        if (authLoading || !user) return;
        const raw = sessionStorage.getItem(PENDING_FAVORITE_ID_KEY);
        if (!raw) return;
        const id = Number(raw);
        if (!Number.isFinite(id)) {
            sessionStorage.removeItem(PENDING_FAVORITE_ID_KEY);
            return;
        }
        if (inFlightFavoriteIds.has(id)) return;
        inFlightFavoriteIds.add(id);

        favoritesService
            .toggle(id)
            .then((result) => {
                sessionStorage.removeItem(PENDING_FAVORITE_ID_KEY);
                onUpdatedRef.current(id, result);
                toast.success(result.isFavorited ? "Added to favorites." : "Removed from favorites.", {
                    theme: "dark",
                });
            })
            .catch(() => {
                sessionStorage.removeItem(PENDING_FAVORITE_ID_KEY);
                toast.error("Could not update favorites.", { theme: "dark" });
            })
            .finally(() => {
                inFlightFavoriteIds.delete(id);
            });
    }, [authLoading, user]);
}
